import { types } from "mobx-state-tree";

const Team = types.model('Team', {
  id: types.identifierNumber,
  name: types.string,
}).actions((self) => ({
  setTeamName(name) {
    self.name = name;
  }
}));

export default Team;
